const data = [
  {
    id: 0,
    theme: "introduction",
    question:
      "Préciser le contexte du projet : Quel est le besoin ou la problématique à résoudre ?",
    type: "text",
  },
  {
    id: 1,
    theme: "budget",
    question: "Quel est votre budget total alloué pour ce projet numérique ?",
    type: "price",
  },
  {
    id: 2,
    theme: "introduction",
    question: "Quels sont les objectifs principaux du projet ?",
    type: "text",
  },
  {
    id: 3,
    theme: "Description générale du projet",
    question: "Quelle est l'idée générale de l'application ?",
    type: "text",
  },
  {
    id: 4,
    theme: "Description générale du projet",
    question:
      "Quelles sont les fonctionnalités clés que l'application doit offrir ?",
    type: "text",
  },
  {
    id: 5,
    theme: "Définition métier",
    question: "Comment l'application générera-t-elle des revenus ?",
    type: "text",
  },
  {
    id: 6,
    theme: "user story",
    question: "Qui sont les utilisateurs finaux de l'application ?",
    type: "text",
  },
  {
    id: 7,
    theme: "user story",
    question:
      "Quelles sont les tâches et besoins spécifiques des utilisateurs ?",
    type: "text",
  },
  {
    id: 8,
    theme: "Contraintes et impératifs",
    question:
      "Quelles sont les contraintes techniques à respecter (compatibilité, sécurité, performance, ordre de grandeur du nombre d'utilisateurs qui viendront sur le site, etc.) ?",
    type: "text",
  },
  {
    id: 9,
    theme: "Eléments graphiques et charte",
    question:
      "Quelle est la vision du design et de l'interface de l'application ?",
    type: "text",
  },
  {
    id: 10,
    theme: "budget",
    question:
      "Disposez-vous déjà d'une base d'utilisateurs payants pour des services similaires à ceux que vous envisagez de mettre en place dans ce projet ?",
    type: "text",
  },
  {
    id: 11,
    theme: "Pour aller plus loin",
    question:
      "Pensez vous réaliser par la suite des versions plus poussées avec plus de fonctionnalités ?",
    type: "text",
  },
    {
    id: 12,
    theme: "budget",
    question:
      "Supposons que votre site n'est pas rentable. Pour le prix qui serait investi, pensez-vous rencontrer des difficultés majeures ou êtes-vous confiant dans votre capacité à rebondir ?",
    type: "text",
  }
];

export default data;
